import { push } from 'connected-react-router';

import { loggedInTransferRx, medications, shop } from 'src/app/router/paths';
import {
  getCurrentPromoOnboardingStepIndex,
  getPromoOnboardingRedirect,
  getPromoOnboardingSteps,
} from 'src/app/state/selectors';

import {
  SET_CURRENT_PROMO_ONBOARDING_STEP,
  SET_NAVIGATE_TO_NEXT_PROMO_ONBOARDING_STEP,
  SET_PROMO_CODE_FOR_ONBOARDING,
  SET_PROMO_ONBOARDING_HAS_EXISTING_ACCOUNT,
  SET_PROMO_ONBOARDING_WORK_EMAIL,
  SET_PROMO_TRANSFER_MEDICATIONS,
  SET_ZIP_CODE_PROMO_SIGN_UP,
} from './types';

export const REDIRECT_POST_ONBOARDING = {
  shop: shop.toPath(),
  home: medications.toPath(),
  loggedInTransferRx: loggedInTransferRx.toPath(),
};

export function setPromoOnboardingZipCode(zipCode) {
  return {
    type: SET_ZIP_CODE_PROMO_SIGN_UP,
    zipCode,
  };
}

export function setNextPromoOnboardingStep() {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();
    const currentStepIndex = getCurrentPromoOnboardingStepIndex(state);
    const promoOnboardingSteps = getPromoOnboardingSteps(state);
    const newStepIndex = currentStepIndex + 1;
    const postOnboardingRedirect = getPromoOnboardingRedirect(state);

    if (newStepIndex < promoOnboardingSteps?.length) {
      dispatch({
        type: SET_NAVIGATE_TO_NEXT_PROMO_ONBOARDING_STEP,
        newStepIndex: currentStepIndex + 1,
      });
    } else {
      dispatch(push(REDIRECT_POST_ONBOARDING[postOnboardingRedirect] ?? medications.toPath()));
    }
  };
}

export function setCurrentPromoOnboardingStep(currentOnboardingStepIndex) {
  return {
    type: SET_CURRENT_PROMO_ONBOARDING_STEP,
    currentOnboardingStepIndex,
  };
}

export function setCurrentPromoTransferMedications(transferMedications) {
  return {
    type: SET_PROMO_TRANSFER_MEDICATIONS,
    transferMedications,
  };
}

export function setPromoOnboardingHasExistingAccount(hasExistingAccount) {
  return {
    type: SET_PROMO_ONBOARDING_HAS_EXISTING_ACCOUNT,
    hasExistingAccount,
  };
}

export function setPromoOnboardingWorkEmail(hasExistingAccount) {
  return {
    type: SET_PROMO_ONBOARDING_WORK_EMAIL,
    hasExistingAccount,
  };
}

export function setPromoCodeForOnboarding(promoCode) {
  return {
    type: SET_PROMO_CODE_FOR_ONBOARDING,
    promoCode,
  };
}
